import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 40px;
	box-sizing: border-box;
	padding: 25px 10px;

	@media (min-width: 600px) {
		width: 80vw;
		max-width: 500px;
	}
`;

export const SectionWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 15px;
	justify-content: center;
	align-items: center;
	width: 90%;
`;

export const Title = styled.div`
	color: #29185e;
	text-align: center;
	font-family: 'Work Sans';
	font-size: 20px;
	font-style: normal;
	font-weight: 700;
	line-height: 140%; /* 28px */
`;

export const Text = styled.div`
	color: var(--Text-color, #29185e);
	font-family: 'Work Sans';
	font-size: 12px;
	font-style: normal;
	font-weight: 500;
	line-height: 100%; /* 12px */
`;

export const ExampleScene = styled.img`
	width: 150px;
`;

export const IconItem = styled.div`
	display: grid;
	grid-template-columns: 20px auto;
	align-items: center;
	gap: 8px;
	width: 100%;
	box-sizing: border-box;
`;

export const Items = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

export const IconImage = styled.img``;
